import {
  GET_CUSTOMER_DETAILS_REQUEST,
  GET_CUSTOMER_DETAILS_RESPONSE,
  GET_REQUEST_STATUS,
  GET_CUSTOMERS_REQUEST,
  GET_CUSTOMERS_RESPONSE,
  BLOCK_OR_UNBLOCK_CUSTOMER,
} from './types';

// list
export const getCustomersRequest = (payload) => ({
  type: GET_CUSTOMERS_REQUEST,
  payload,
});

export const getCustomersResponse = (payload) => ({
  type: GET_CUSTOMERS_RESPONSE,
  payload,
});

// get by id (view)
export const getCustomerDetailsRequest = (payload) => ({
  type: GET_CUSTOMER_DETAILS_REQUEST,
  payload,
});

export const getCustomerDetailsResponse = (payload) => ({
  type: GET_CUSTOMER_DETAILS_RESPONSE,
  payload,
});

export const blockOrUnblockCustomer = (payload) => ({
  type: BLOCK_OR_UNBLOCK_CUSTOMER,
  payload,
});

export const getRequestStatus = (payload) => ({
  type: GET_REQUEST_STATUS,
  payload,
});
